import React from 'react';
import PropTypes from 'prop-types';

import styles from './Breadcrumb.module.scss';

function Breadcrumb({ title, breadcrumb }) {
  return (
    <div className="m-b-15">
      <ul className="w-100 d-flex f-wrap">
        {breadcrumb?.map((item, index) => (
          <li key={index} className={styles.breadcrumb_item}>
            <a href={item.href}>
              {item.label}
            </a>
          </li>
        ))}

        {title ? (
          <li className={styles.breadcrumb_item}>{title}</li>
        ) : null}
      </ul>
    </div>
  );
}

Breadcrumb.propTypes = {
  title: PropTypes.string,
  breadcrumb: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
};

Breadcrumb.defaultProps = {
  title: null,
};

export default Breadcrumb;
